import { SvgIcon, SvgIconProps } from '@mui/material';

export const ClientIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        className='icon icon-client icons-client-outline icon-client-user-plus'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0' />
        <path d='M16 19h6' />
        <path d='M19 16v6' />
        <path d='M6 21v-2a4 4 0 0 1 4 -4h4' />
      </svg>
    </SvgIcon>
  );
};
